export enum SORT_OPTIONS {
    OLDEST_TO_NEWEST = 'from_oldest_to_newest',
    NEWEST_TO_OLDEST = 'from_newest_to_oldest',
    AUTHENTICITY = 'authenticity',
    SIMILARITY = 'similarity',
}
